import { keyframes } from 'styled-components';

export const colors = {
  // Cores primárias
  red: 'rgb(166, 3, 14)',
  darkBlue: 'rgb(13, 35, 87)',
  lightBlue: 'rgb(124, 176, 235)',

  // Tons neutros
  white: '#ffffff',
  darkGray: '#333333',
  lightGray: '#e1e5e9',

  // Variações para gradientes e efeitos
  blueDark: '#0d2257',        // Versão mais escura do azul institucional
  blueMedium: '#1a3a8f',       // Tom médio para transições
  blueLight: '#2a4ba8',        // Tom mais claro para hover

  // Cores auxiliares
  backgroundLight: '#f8fafc',   // Fundo claro para cards e seções
  borderLight: '#e2e8f0',       // Bordas suaves
  textMuted: '#64748b'          // Texto secundário/desabilitado
};

// Slides usados na transição entre as telas de login e cadastro (duration 0.6s, ease-in-out)
export const slideOutToLeft = keyframes`
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(-100%);
    opacity: 0;
  }
`;

export const slideInFromRight = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

export const slideOutToRight = keyframes`
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
`;

export const slideInFromLeft = keyframes`
  from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

// Fade in para entrada suave de elementos (duration 0.5s recomendado)
export const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const breakpoints = {
  small: '480px',
  mobile: '768px',
  tablet: '1024px',
  desktop: '1200px'
};
